import { Dispatch } from '@reduxjs/toolkit';
import { setGeographies } from '../actions';
import { AppState } from '../store';

export function getGeography(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/Geography`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const geographies = await data.json();
      dispatch(setGeographies(geographies));
    } catch (error) {
      console.error(error);
    }
  };
}
